var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EDF5FF",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.062 31.27-8.153-2.265h-9.164L5.593 31.27A7.636 7.636 0 0 0 0 38.628v7.954h36.655v-7.954c0-3.43-2.288-6.44-5.593-7.359z",
    fill: "#60B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26A6FE",
    d: "M6.11 42h1.526v4.582H6.11zM22.91 29.005h-9.165l-1.506.419c.21 3.179 2.857 5.703 6.088 5.703 3.232 0 5.879-2.524 6.089-5.703l-1.507-.419z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.91 23.66h-9.165v5.345l.001.001v.012a4.582 4.582 0 1 0 9.163 0V23.66z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.49 9.914v7.65a9.164 9.164 0 0 1-18.326 0v-7.65H27.49zM27.49 12.218h.53c.93 0 1.643.823 1.512 1.744l-.326 2.278a1.527 1.527 0 0 1-1.512 1.31h-.203v-5.332z",
    fill: "#FFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.164 12.218h-.53c-.929 0-1.643.823-1.512 1.744l.327 2.278c.107.752.752 1.31 1.512 1.31h.203v-5.332z",
    fill: "#FFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.49 17.55-1.526-6.108H10.69L9.164 17.55V8.4A7.636 7.636 0 0 1 16.8.764h3.818a3.055 3.055 0 0 1 3.055 3.054 3.819 3.819 0 0 1 3.818 3.818v9.915z",
    fill: "#6E83B7"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFB0AA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.364 6.873h-1.528V1.527h-5.345V0h6.873zM3.818 6.873H2.291V0h6.873v1.527H3.818zM34.364 29.018H27.49v-1.527h5.345v-5.346h1.528zM9.164 29.018H2.29v-6.873h1.527v5.346h5.346zM2.29 13.745h32.074v1.528H2.29z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#98CA69",
    cx: 36.6,
    cy: 38.945,
    r: 7.636
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDEFF1",
    cx: 36.6,
    cy: 38.945,
    r: 6.109
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98CA69",
    d: "m35.836 41.934-2.83-2.83 1.08-1.08 1.75 1.75 3.851-3.85 1.08 1.08z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.1c0fefdf14a4563ba172f0a857084168.svg";
export { ForwardRef as ReactComponent };